import { SIDEBAR_ACTIONS } from "../constants/actionsConstants";

const initalState = {
  contentComponents: []
};

const sidebarReducer = (state = initalState, action) => {
  switch (action.type) {
    case SIDEBAR_ACTIONS.OPEN_SIDEBAR:
      return {
        ...state,
        contentComponents: [...state.contentComponents, { ...action.payload, isOpen: true }]
      };
    case SIDEBAR_ACTIONS.CLOSE_SIDEBAR:
      return {
        ...state,
        contentComponents: action.payload?.componentKey 
          ? state.contentComponents.filter(item => item.componentKey !== action.payload.componentKey)
          : []
      };
    default:
      return state;
  }
};

export default sidebarReducer;
